import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "text-center"
}, "请选择登录身份", -1);
const _hoisted_2 = {
  class: "identity-card-container flex-between"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", {
  class: "text-center"
}, "普通商家", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center"
}, " 在京麦应用市场订阅了ISV打单软件的商家，可使用ISV提供的模板服务 ", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "identity-cover"
}, null, -1);
const _hoisted_6 = [_hoisted_3, _hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", {
  class: "text-center"
}, "自研商家", -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center"
}, "自研软件对接京东云打印的商家", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "identity-cover"
}, null, -1);
const _hoisted_10 = [_hoisted_7, _hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", {
  class: "text-center"
}, "ISV服务商", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center"
}, "为普通商家提供面单打印服务的独立软件服务商", -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "identity-cover"
}, null, -1);
const _hoisted_14 = [_hoisted_11, _hoisted_12, _hoisted_13];
const _hoisted_15 = {
  class: "dialog-footer"
};
const _hoisted_16 = {
  class: "fl"
};
const _hoisted_17 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    class: "identity-dialog",
    modelValue: _ctx.state.visible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.state.visible = $event),
    title: "",
    width: "760px",
    "show-close": false,
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("div", _hoisted_16, [!_ctx.props.services || !_ctx.props.services.length ? (_openBlock(), _createElementBlock("p", _hoisted_17, [_createTextVNode(" 您未订阅任何ISV软件，请到"), _createVNode(_component_el_link, {
      type: "primary",
      href: "https://fw.jd.com/",
      target: "_blank"
    }, {
      default: _withCtx(() => [_createTextVNode("京麦服务市场")]),
      _: 1
    }), _createTextVNode("订阅 ")])) : (_openBlock(), _createBlock(_component_el_select, {
      key: 1,
      modelValue: _ctx.state.service,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.state.service = $event),
      placeholder: "请选择服务商",
      size: "default"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.services, item => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"]))], 512), [[_vShow, _ctx.state.identity === '0']]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.onUse,
      disabled: _ctx.disableUse
    }, {
      default: _withCtx(() => [_createTextVNode("开始使用")]),
      _: 1
    }, 8, ["onClick", "disabled"])])]),
    default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: _normalizeClass(["identity-card", {
        'is-active': _ctx.state.identity === '0'
      }]),
      onClick: _cache[0] || (_cache[0] = $event => _ctx.onChoose('0'))
    }, _hoisted_6, 2), _createElementVNode("div", {
      class: _normalizeClass(["identity-card", {
        'is-active': _ctx.state.identity === '2'
      }]),
      onClick: _cache[1] || (_cache[1] = $event => _ctx.onChoose('2'))
    }, _hoisted_10, 2), _createElementVNode("div", {
      class: _normalizeClass(["identity-card", {
        'is-active': _ctx.state.identity === '1'
      }]),
      onClick: _cache[2] || (_cache[2] = $event => _ctx.onChoose('1'))
    }, _hoisted_14, 2)])]),
    _: 1
  }, 8, ["modelValue"]);
}